import axios from "axios";

const API = axios.create({ baseURL: "https://digital-archiving-app.herokuapp.com" });

API.interceptors.request.use((req) => {
  if (localStorage.getItem("profile")) {
    req.headers.authorization = `Bearer ${
      JSON.parse(localStorage.getItem("profile")).token
    }`;
  }
  return req;
});

//Api call for our retriving posts 
export const fetchPosts = () => API.get("/posts");

//Api call for creating posts
export const createPost = (newPost) => API.post("/posts", newPost);
//Api call for deleting posts
export const deletePost = (id) => API.delete(`/posts/${id}`);

//Api call for liking posts

export const likePost = (id) => API.patch(`/posts/${id}/likePost`);

export const updatePost = (id, updatedPost) =>
  API.patch(`/posts/${id}`, updatedPost);

export const signIn = (formData) => API.post("/users/signin", formData);
export const signUp = (formData) => API.post("/users/signup", formData);
